<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M17.28 9.2a4.1 4.1 0 0 0-2.7-7.2H8.72a4.12 4.12 0 0 0-4.12 4.12c0 1.23.55 2.33 1.42 3.08a7.65 7.65 0 1 0 11.27 0ZM8.71 4.35h5.88a1.76 1.76 0 0 1 .8 3.33 7.57 7.57 0 0 0-7.48 0c-.58-.3-.97-.88-.97-1.56 0-.98.79-1.77 1.77-1.77Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
